"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaximumPrefundingAmount = exports.createMaximumPrefundingAmountAvailableFieldProposals = exports.createMaximumPrefundingAmountEvaluator = exports.checkMaximumPrefundingAmountConfigErrors = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const AVAILABLE_FORMULA_FIELDS = {
    commitmentAmount: 'total commitment amount of all capital providers',
};
/**
 * Maximum prefunding amount formulas can use variables from {@link CreditAgreement.Config.MaximumPrefundingAmount.AvailableFormulaFields}
 */
const checkMaximumPrefundingAmountConfigErrors = ({ maximumPrefundingAmountConfig, }) => {
    const availableFormulaFields = Object.keys(AVAILABLE_FORMULA_FIELDS);
    const availableVariables = new Set(availableFormulaFields);
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.type === 'formula', `unexpected maximumPrefundingAmountConfig.type: [${maximumPrefundingAmountConfig.type}]`);
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(maximumPrefundingAmountConfig.config.formula, availableVariables);
    return errorMessages;
};
exports.checkMaximumPrefundingAmountConfigErrors = checkMaximumPrefundingAmountConfigErrors;
const createMaximumPrefundingAmountEvaluator = (maximumPrefundingAmountConfig) => {
    // extract formula from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.type === 'formula', `Expected maximum prefunding amount config type [${maximumPrefundingAmountConfig.type}] to be formula`);
    (0, common_1.finleyAssert)(maximumPrefundingAmountConfig.config.engineVersion ===
        finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${maximumPrefundingAmountConfig.config.engineVersion} is not supported for HyperForumla engine`);
    const formulaString = maximumPrefundingAmountConfig.config.formula;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString], undefined);
    const evaluateConfig = (availableFields) => {
        formulaEngine.setVariables(availableFields, { flatten: true });
        return formulaEngine.evaluateNumber(formulaString);
    };
    return {
        evaluateConfig,
    };
};
exports.createMaximumPrefundingAmountEvaluator = createMaximumPrefundingAmountEvaluator;
const createMaximumPrefundingAmountAvailableFieldProposals = () => {
    return _.map(_.toPairs(AVAILABLE_FORMULA_FIELDS), ([label, documentation]) => ({
        label,
        documentation,
        insertText: label,
    }));
};
exports.createMaximumPrefundingAmountAvailableFieldProposals = createMaximumPrefundingAmountAvailableFieldProposals;
/**
 * expected that this will be refactored to be an async method when pointer methods are implemented
 */
const calculateMaximumPrefundingAmount = ({ maximumPrefundingAmountConfig, availableFields, }) => {
    if (!maximumPrefundingAmountConfig) {
        return 0; // default value
    }
    switch (maximumPrefundingAmountConfig.type) {
        case 'formula':
            return (0, exports.createMaximumPrefundingAmountEvaluator)(maximumPrefundingAmountConfig).evaluateConfig(availableFields);
        // case 'pointer':
        // TO BE IMPLEMENTED
        default:
            return (0, common_1.finleyAssertUnreachable)(maximumPrefundingAmountConfig.type);
    }
};
exports.calculateMaximumPrefundingAmount = calculateMaximumPrefundingAmount;
//# sourceMappingURL=maximumPrefundingAmountEvaluator.js.map